// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1CUTV","consentsList":"PatientConsents_consentsList__3JCkw","consentsListEmpty":"PatientConsents_consentsListEmpty__3Rfbd"};